<template>
  <section
    v-editable="blok"
    class="flex flex-col gap-8 md:grid md:grid-flow-col"
    :class="[
      marginClasses,
      {
        'mx-break-out':
          (!cmsParentBlok || cmsParentBlok.component === 'BlogOverview') &&
          blok.wholeWidth,
      },
      {
        'grid-fix-size--small-right': blok.size_columns === 'smallRight',
        'grid-fix-size--small-left': blok.size_columns === 'smallLeft',
      },
      { 'gap-0': blok.removeMargin_sides },
    ]"
  >
    <!-- Image is not allowed as a component so we have to rename it here -->
    <component
      :is="['Image'].includes(column.component) ? 'CmsImage' : column.component"
      v-for="(column, index) in blok.columns"
      :key="column._uid"
      class="grid-fix-size__column"
      :blok="column"
      :sibling-index="index"
    />
  </section>
</template>

<script lang="ts">
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import type {
  SbGridFixSize,
  BaseStoryblokComponent,
} from '~/cms/storyblok/types/storyblok.d.ts'

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<SbGridFixSize>,
      required: true,
    },
  },
  setup(props) {
    const { marginClasses } = useStoryblokMargins(props.blok)
    const instance = getCurrentInstance()
    const cmsParentBlok = computed(
      () =>
        ((instance as any)?.parent?.props?.blok as
          | BaseStoryblokComponent
          | undefined) || null,
    )

    return {
      cmsParentBlok,
      marginClasses,
    }
  },
})
</script>
<style lang="postcss" scoped>
/* Use fr so gap is included in track sizing; 70%+30%+gap would overflow the container */
.grid-fix-size--small-right {
  grid-auto-columns: 7fr 3fr;
}
.grid-fix-size--small-left {
  grid-auto-columns: 3fr 7fr;
}
.grid-fix-size__column {
  min-width: 0;
}
</style>
